import React from 'react';
import createReactClass from 'create-react-class';
import MenuItem from './MenuItem';

var MainMenu = createReactClass({


  render() {
    return (
      <nav>
        <ul>
          <MenuItem displayName="Home" to="/" icon="home" claim="dashboard:read" />
          <MenuItem displayName="Lagerbestand" to="/items" icon="cubes" claim="items:read" />
          <MenuItem displayName="Lieferanten" to="/vendors" icon="paper-plane-o" claim="vendors:read" />

          <MenuItem displayName="Bestellvorschläge" to="/purchasesuggestions/overview" matchhint="/purchasesuggestions" icon="file-archive-o" claim="purchasesuggestions:read" />

          <MenuItem displayName="Bestellungen" icon="truck" matchhint="/purchaseorders" claim="purchaseorders:read">
            <MenuItem displayName="Genehmigte Bestellungen" to="/purchaseorders/overview" claim="purchaseorders:read"/>
            <MenuItem displayName="Offene Bestellungen" matchhint="/purchaseorders/ordered" to="/purchaseorders/ordered/overview" claim="purchaseorders:read" />
            <MenuItem displayName="Historie" matchhint="/purchaseordershistory" to="/purchaseordershistory" claim="purchaseorders:read" />
          </MenuItem>

          <MenuItem displayName="Lagerorte" to="/storagelocations" icon="inbox" claim="storagelocations:read" />
          {/*<MenuItem displayName="Entnahme" to="/withdrawals/new" icon="folder-o" />*/}
          <MenuItem displayName="Inventur" to="/stocktaking" icon="pencil" claim="stocktaking:read" />

          <MenuItem displayName="Reports" matchhint="/reports" icon="clock-o" claim="timepark:read">
            <MenuItem displayName="BDE Buchungen" to="/reports/bde_buchungen" claim="timepark:read" />
            <MenuItem displayName="Timepark" to="/reports/timepark" claim="timepark:read" />
          </MenuItem>

        </ul>
      </nav>
    );
  }
});

export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/common/MainMenu/index.js